import { TableContainer, Box, IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Chip from '../../components/Chip';
import SearchBar from '../../components/SearchBar';
import TableComponent from '../../components/TableComponent';
import { showError } from '../../constants/toasts';
import { useLazyGetAddListingQuery } from '../../service/listing';
import { Listing } from '../../types/General';
import { APPROVAL_STATUS } from '../../utils/enums';

const UserListings: FC<{ role: any }> = ({ role }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [hidden, setHidden] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [getAddListing] = useLazyGetAddListingQuery();
  const [rows, setRows] = useState<Listing[]>([]);
  const [count, setCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const onPageChange = (e: any, newPage: number) => {
    setPage(newPage + 1);
  };
  const [anchorEl1, setAnchorEl1] = useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const getStatusStyles = (status: APPROVAL_STATUS) => {
    switch (status) {
      case APPROVAL_STATUS.PENDING + 1:
        return {
          label: 'Pending',
          color: '#FF9800',
          backgroundColor: '#FFF3E0',
        };
      case APPROVAL_STATUS.APPROVED + 1:
        return {
          label: 'Approved',
          color: '#4CAF50',
          backgroundColor: '#E8F5E9',
        };
      case APPROVAL_STATUS.REJECTED + 1:
        return {
          label: 'Rejected',
          color: '#F44336',
          backgroundColor: '#FFEBEE',
        };
      default:
        return {
          label: 'Unknown',
          color: '#9E9E9E',
          backgroundColor: '#F5F5F5',
        };
    }
  };

  // const rows = [
  //   {
  //     id: 1,
  //     vehicleType: 1,
  //     address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
  //     approvalStatus: 1,
  //   },
  //   {
  //     id: 2,
  //     vehicleType: 2,
  //     address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
  //     approvalStatus: 2,
  //   },
  //   {
  //     id: 3,
  //     vehicleType: 3,
  //     address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
  //     approvalStatus: 3,
  //   },
  //   {
  //     id: 4,
  //     vehicleType: 4,
  //     address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
  //     approvalStatus: 1,
  //   },
  //   {
  //     id: 5,
  //     vehicleType: 1,
  //     address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
  //     approvalStatus: 1,
  //   },
  // ];
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.6,
      minWidth: 200,
      field: 'vehicle',
      headerName: 'Vehicle Details',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="sq_image" style={{ marginTop: '16px' }}>
            <figure
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/listing-detail/${row?.vehicleType}/${row?._id}`)}
            >
              <img
                src={row?.coverImage ? row?.coverImage : '/static/images/vehicle_side.jpg'}
                alt=""
              />
            </figure>
            <p>
              <b>{row?.title}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: 'vehicleType',
      headerName: 'Vehicle Type',
      editable: false,
      sortable: false,
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: 'isPremiumCar',
      headerName: 'Premium',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return <>{row?.isPremiumCar ? 'Yes' : 'No'}</>;
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: 'status',
      headerName: 'Approval Status',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const statusStyles = getStatusStyles(row?.status);
        return (
          <Chip
            label={statusStyles.label}
            color={statusStyles.color}
            backgroundColor={statusStyles.backgroundColor}
          />
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? 'basic-menu1' : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? 'true' : undefined}
                onClick={() => navigate(`/listing-detail/${row?.vehicleType}/${row?._id}`)}
              >
                <img src="/static/images/view.png" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];

  const getAddListingAll = async () => {
    setIsLoading(true);
    try {
      const response = await getAddListing({
        page,
        limit: 10,
        id,
        role: Number(role?.role),
      }).unwrap();
      setIsLoading(false);

      if (response?.statusCode === 200) {
        setCount(response?.data?.count);
        setRows(response?.data?.data);
      } else {
        // setRows([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAddListingAll();
  }, [page]);

  return (
    <>
      <div className="invitedPersons_info">
        <TableContainer className="table_container">
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search"
                />
              </Box>
            </div>
          </div>

          <div className="sorting_table">
            {rows && (
              <TableComponent
                columns={columns?.filter((item: any) => !hidden.includes(item.field))}
                rows={rows}
                count={count}
                page={page}
                onPageChange={onPageChange}
                loading={isLoading}
              />
            )}
          </div>
        </TableContainer>
      </div>
    </>
  );
};

export default UserListings;
